// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["assets/css/main.min"], () => (__webpack_require__("./assets/js/main.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/css/main.min"], () => (__webpack_require__("./assets/sass/main.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
